export const namespaced = true;

import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import i18n from "../../../i18n";

export const state = {
    plot: null,
    barrier: null,
    elements: [],
    additionalWorks: {
        install: null
    },
    name: "",
    phone: "",
    email: "",

    weight: 0,
    faces: [],
    activeFaceIndex: null,
    engravingsUpdatedAt: null,
    orderIdFromCache: null,
    landscaping: {
        mainElementType: null,
        mainElement: null,
        facing_top: null,
        facing_side: null,
        fillType: null,
        fillElement: null,
        borderElement: null
    },
    mockup: "",
    renderer: null,
    successOrder: null,
    changed: false,
    total: 0,
    totalCost: 0,
    engravingTotal: 0,
    engravingTotalCost: 0,
    addedElementsInstallTotal: 0,
    addedElementsInstallTotalCost: 0,
    installTotal: 0,
    installTotalCost: 0,
};

import { markRaw } from "vue";

export const mutations = {

    SET_CHANGED(state, changed) {
        state.changed = changed;
    },

    SET_ENGRAVINGS_UPDATED_AT(state) {
        state.engravingsUpdatedAt = Date.now();
    },

    SET_SUCCESS_ORDER(state, successOrder) {
        state.successOrder = successOrder;
    },

    CLEAR_SUCCESS_ORDER(state) {
        state.successOrder = null;
    },


    SET_PLOT(state, plot) {
        state.plot = plot;
    },

    SET_PLOT_MODE(state, mode) {
        state.plot = { ...state.plot, mode };
    },

    SET_PLOT_SIZE(state, { length, width }) {
        const name = `Участок [${width} x ${length}]`;
        const size = `${width} x ${length}`;
        if (state.plot) {
            state.plot = { ...state.plot, width, length, name, size };
        } else {
            state.plot = { mode: "custom", width, length, name, size };
        }

    },

    SET_RENDERER(state, renderer) {
        state.renderer = markRaw(renderer);
    },

    SET_MOCKUP(state, mockup) {
        state.mockup = mockup;
    },

    ADD_BARRIER(state, barrier) {
        state.barrier = { ...barrier };
    },

    REMOVE_BARRIER(state) {
        state.barrier = null;
    },

    ADD_ADDITIONAL_WORK(state, { type, additionalWork }) {
        state.additionalWorks[type] = additionalWork;
    },

    REMOVE_ADDITIONAL_WORK(state, type) {
        state.additionalWorks[type] = null;
    },

    ADD_ELEMENT(state, element) {
        state.elements = state.elements.filter(
            el => el.element_group_id !== element.element_group_id
        );
        state.elements.push(element);
    },

    ADD_FACE(state, face) {
        state.faces.push(face);
    },

    SET_FACE_IMAGE(state, { faceId, image }) {
        const faceIndex = state.faces.findIndex(f => f.face_id == faceId);

        if (faceIndex >= 0) {
            state.faces[faceIndex].image = image;
            state.faces = [...state.faces];
        }
    },

    SET_FACE_FINAL_IMAGE(state, { faceId, finalImage }) {

        const faceIndex = state.faces.findIndex(f => f.face_id == faceId);
        if (faceIndex >= 0) {
            state.faces[faceIndex].finalImage = finalImage;
            state.faces = [...state.faces];
        }
    },

    CLEAR_ACTIVE_FACE_FINAL_IMAGE(state) {
        if (state.activeFaceIndex === null || !state.faces[state.activeFaceIndex]) {
            return;
        }
        state.faces[state.activeFaceIndex].finalImage = null;
    },

    CLEAR_FACE_FINAL_IMAGE(state, { faceId }) {
        const faceIndex = state.faces.findIndex(f => f.face_id == faceId);
        if (faceIndex >= 0) {
            state.faces[faceIndex].finalImage = null;
        }
    },

    REMOVE_FACE_ELEMENT(state, element_id) {
        state.faces = state.faces.filter(face => face.element_id != element_id);
        state.faces = [...state.faces];
    },

    CLEAR_FACES_ELEMENT_GROUP(state, element_group_id) {
        state.faces = state.faces.filter(
            face => face.element_group_id != element_group_id
        );
    },

    SET_ACTIVE_FACE_INDEX(state, index) {
        state.activeFaceIndex = index;
    },

    SET_ORDER_ID_FROM_CACHE(state, orderId) {
        state.orderIdFromCache = orderId;
    },

    SELECT_ENGRAVING(state, element) {
        state.faces[state.activeFaceIndex].elements.push(element);
        state.faces = [...state.faces];
    },

    ADD_TEXT(state, text) {
        state.faces[state.activeFaceIndex].texts.push(text);
        state.faces = [...state.faces];
    },

    SET_TEXT(state, setText) {
        const textIndex = state.faces[state.activeFaceIndex].texts.findIndex(
            txt => txt.text_id == setText.text_id
        );
        if (
            textIndex != null &&
            state.faces[state.activeFaceIndex].texts[textIndex]
        ) {
            state.faces[state.activeFaceIndex].texts[textIndex] = setText;

            state.faces = [...state.faces];
        }
    },

    UPDATE_ENGRAVING_MESH_ID(state, { element_uuid, meshId }) {
        const engrElIndex = state.faces[
            state.activeFaceIndex
        ].elements.findIndex(el => el.uuid == element_uuid);
        if (engrElIndex == 0 || engrElIndex > 0) {
            state.faces[state.activeFaceIndex].elements[
                engrElIndex
            ].meshId = meshId;
        } else {
            const textIndex = state.faces[
                state.activeFaceIndex
            ].texts.findIndex(txt => txt.text_id == element_uuid);
            if (
                textIndex != null &&
                state.faces[state.activeFaceIndex].texts[textIndex]
            ) {
                state.faces[state.activeFaceIndex].texts[
                    textIndex
                ].meshId = meshId;
            }
        }
    },

    UPDATE_ENGRAVING_POSITION(state, moveObj) {
        const engrElIndex = state.faces[
            state.activeFaceIndex
        ].elements.findIndex(el => el.meshId == moveObj.uuid);
        if (engrElIndex == 0 || engrElIndex > 0) {
            state.faces[state.activeFaceIndex].elements[engrElIndex].position =
                moveObj.position;
        } else {
            const textIndex = state.faces[
                state.activeFaceIndex
            ].texts.findIndex(txt => txt.meshId == moveObj.uuid);
            if (
                textIndex != null &&
                state.faces[state.activeFaceIndex].texts[textIndex]
            ) {
                state.faces[state.activeFaceIndex].texts[textIndex].position =
                    moveObj.position;
            }
        }
    },

    UPDATE_FACES(state) {
        state.faces = [...state.faces];
    },

    UPDATE_ENGRAVING_ELEMENT(state, { element_uuid, value, key }) {
        const engrElIndex = state.faces[
            state.activeFaceIndex
        ].elements.findIndex(el => el.uuid == element_uuid);
        if (engrElIndex == 0 || engrElIndex > 0) {
            state.faces[state.activeFaceIndex].elements[
                engrElIndex
            ][key] = value;
            // state.faces = [...state.faces];
        } else {
            const textIndex = state.faces[
                state.activeFaceIndex
            ].texts.findIndex(txt => txt.element_id == element_uuid);
            if (
                textIndex != null &&
                state.faces[state.activeFaceIndex].texts[textIndex]
            ) {
                state.faces[state.activeFaceIndex].texts[textIndex][key] = value;
                // state.faces = [...state.faces];
            }
        }
    },

    UPDATE_ENGRAVING_SIZE(state, { element_id, size }) {
        const engrElIndex = state.faces[
            state.activeFaceIndex
        ].elements.findIndex(el => el.element_id == element_id);
        if (engrElIndex == 0 || engrElIndex > 0) {
            state.faces[state.activeFaceIndex].elements[
                engrElIndex
            ].size = size;
            state.faces = [...state.faces];
        }
    },

    REMOVE_TEXT(state, { face_id, text_id }) {
        const faceIndex = state.faces.findIndex(
            face => face.face_id == face_id
        );
        if (faceIndex != null && state.faces[faceIndex]) {
            state.faces[faceIndex].texts = state.faces[faceIndex].texts.filter(
                element => element.text_id != text_id
            );
            state.faces[faceIndex].texts = [...state.faces[faceIndex].texts];
            state.faces = [...state.faces];
        }
        state.elements = [...state.elements];
    },

    //update.engraving.position
    //update.engraving.rotate

    REMOVE_ENGRAVING(state, { face_id, element_id, uuid }) {
        const faceIndex = state.faces.findIndex(
            face => face.face_id == face_id
        );

        if (faceIndex != null && state.faces[faceIndex]) {
            if (uuid) {
                state.faces[faceIndex].elements = state.faces[
                    faceIndex
                ].elements.filter(element => element.uuid != uuid);
            } else {
                state.faces[faceIndex].elements = state.faces[
                    faceIndex
                ].elements.filter(element => element.element_id != element_id);
            }


            state.faces[faceIndex].elements = [
                ...state.faces[faceIndex].elements
            ];
            state.faces = [...state.faces];
        }
        state.elements = [...state.elements];
    },

    REMOVE_ENGRAVING_FACE_ELEMENTS(state, face_id) {
        const faceIndex = state.faces.findIndex(
            face => face.face_id == face_id
        );
        if (faceIndex != null && state.faces[faceIndex]) {
            state.faces[faceIndex].elements = [];
            state.faces[faceIndex].texts = [];
            state.faces = [...state.faces];
        }
        state.elements = [...state.elements];
    },

    UPDATE_ELEMENT_SIZE(state, { element_id, size }) {

        const element = state.elements.find(el => el.element_id == element_id);
        const elementIndex = state.elements.findIndex(
            el => el.element_id == element_id
        );

        if (element && size) {

            element.size = size;

            if (element.type_calc_cost == 'cub' && element.material) {
                const priceMaterial = parseFloat(element.material.price);
                const costMaterial = parseFloat(element.material.cost);
                if (priceMaterial > 0) {
                    const sizeVolume = parseFloat(size.volume);
                    if (sizeVolume > 0) {
                        element.total = sizeVolume * priceMaterial;
                        if (costMaterial) {
                            element.totalCost = sizeVolume * costMaterial;
                        } else {
                            element.totalCost = element.total;
                        }
                    } else {
                        const calcVolume = (parseFloat(size.width) / 100) * (parseFloat(size.length) / 100) * (parseFloat(size.height) / 100);
                        element.total = calcVolume * priceMaterial;
                        if (costMaterial) {
                            element.totalCost = calcVolume * costMaterial;
                        } else {
                            element.totalCost = element.total;
                        }
                    }
                    //учет сложности
                    const sizeComplexity = parseFloat(size.complexity);
                    if (element.type_calc_complexity == 'coef' && sizeComplexity > 0) {
                        element.total *= sizeComplexity;
                        element.totalCost *= sizeComplexity;
                    }
                    if (element.type_calc_complexity == 'fix' && sizeComplexity) {
                        element.total += sizeComplexity;
                        element.totalCost += sizeComplexity;
                        if (element.total < 0) {
                            element.total = 0;
                            element.totalCost = 0;
                        }
                    }
                } else {
                    element.total = 0;
                    element.totalCost = 0;
                }
            } else {
                const priceElement = parseFloat(size.price);
                const costElement = parseFloat(size.cost);

                element.total = priceElement;

                if (costElement) {
                    element.totalCost = costElement;
                } else {
                    element.totalCost = priceElement;
                }

                if (element.material) {
                    element.total *= parseFloat(element.material.cost_coefficient);
                    element.totalCost *= parseFloat(element.material.cost_coefficient);
                }
            }

            if (element.polish) {
                element.total += parseFloat(element.polish.price);
                const polishCost = parseFloat(element.polish.cost);
                if (polishCost) {
                    element.totalCost += polishCost;
                }
            }

            if (element.services && element.services.length) {
                for (const service of element.services) {
                    element.total += service.price;
                    element.totalCost += service.cost;
                }
            }
        }

        for (let index = 0; index < state.faces.length; index++) {
            if (state.faces[index].element_id == element_id) {
                state.faces[index].element = element;
            }
        }

        state.elements[elementIndex] = element;
        state.elements = [...state.elements];
    },

    UPDATE_ELEMENT_MATERIAL(state, { element_id, material }) {
        const element = state.elements.find(el => el.element_id == element_id);
        const elementIndex = state.elements.findIndex(
            el => el.element_id == element_id
        );

        if (element) {

            element.material = material;

            if (element.size) {

                if (element.type_calc_cost == 'cub') {

                    const priceMaterial = parseFloat(material.price);
                    const costMaterial = parseFloat(material.cost);

                    if (priceMaterial > 0) {
                        const sizeVolume = parseFloat(element.size.volume);
                        if (sizeVolume > 0) {
                            element.total = sizeVolume * priceMaterial;
                            if (costMaterial) {
                                element.totalCost = sizeVolume * costMaterial;
                            } else {
                                element.totalCost = element.total;
                            }
                        } else {
                            const calcVolume = (parseFloat(element.size.width) / 100) * (parseFloat(element.size.length) / 100) * (parseFloat(element.size.height) / 100);
                            element.total = calcVolume * priceMaterial;
                            if (costMaterial) {
                                element.totalCost = calcVolume * costMaterial;
                            } else {
                                element.totalCost = element.total;
                            }
                        }
                        //учет сложности
                        const sizeComplexity = parseFloat(element.size.complexity);
                        if (element.type_calc_complexity == 'coef' && sizeComplexity > 0) {
                            element.total *= sizeComplexity;
                            element.totalCost *= sizeComplexity;
                        }
                        if (element.type_calc_complexity == 'fix' && sizeComplexity) {
                            element.total += sizeComplexity;
                            element.totalCost += sizeComplexity;
                            if (element.total < 0) {
                                element.total = 0;
                                element.totalCost = 0;
                            }
                        }
                    } else {
                        element.total = 0;
                        element.totalCost = 0;
                    }
                } else {
                    let elPrice = parseFloat(element.size.price);
                    let elCost = parseFloat(element.size.cost) || elPrice;

                    if (
                        element.material &&
                        parseFloat(element.material.cost_coefficient)
                    ) {
                        elPrice *= parseFloat(element.material.cost_coefficient);
                        elCost *= parseFloat(element.material.cost_coefficient);

                    }
                    // elPrice += parseFloat(element.size.cost_coefficient);
                    element.total = elPrice;
                    element.totalCost = elCost;
                }
            }

            if (element.polish) {
                element.total += parseFloat(element.polish.price);
                const polishCost = parseFloat(element.polish.cost);
                if (polishCost) {
                    element.totalCost += polishCost;
                }
            }

            if (element.services && element.services.length) {
                for (const service of element.services) {
                    element.total += service.price;
                    element.totalCost += service.cost;
                }
            }
        }
        for (let index = 0; index < state.faces.length; index++) {
            if (state.faces[index].element_id == element_id) {
                state.faces[index].element = element;
            }
        }
        state.elements[elementIndex] = element;
        state.elements = [...state.elements];
    },

    UPDATE_ELEMENT_POLISH(state, { element_id, polish }) {
        const element = state.elements.find(el => el.element_id == element_id);
        const elementIndex = state.elements.findIndex(
            el => el.element_id == element_id
        );
        if (element) {
            element.polish = polish;
            if (element.size) {
                let elPrice = parseFloat(element.size.price);
                let elCost = parseFloat(element.size.cost);
                if (
                    element.material &&
                    parseFloat(element.material.cost_coefficient)
                ) {
                    elPrice *= parseFloat(element.material.cost_coefficient);
                    if (elCost) {
                        elCost *= parseFloat(element.material.cost_coefficient);
                    } else {
                        elCost = elPrice;
                    }

                }
                // elPrice += parseFloat(element.size.cost_coefficient);
                element.total = elPrice;
                element.totalCost = elCost;
            }

            if (polish && polish.price) {
                element.total += parseFloat(polish.price);
                const polishCost = parseFloat(polish.cost);
                if (polishCost) {
                    element.totalCost += polishCost;
                }
            }

            if (element.services && element.services.length) {
                for (const service of element.services) {
                    element.total += service.price;
                    element.totalCost += service.cost;
                }
            }
        }
        state.elements[elementIndex] = element;
        state.elements = [...state.elements];
    },

    UPDATE_ELEMENT_SERVICE(state, { element_id, service, remove = false }) {
        const element = state.elements.find(el => el.element_id == element_id);
        const elementIndex = state.elements.findIndex(
            el => el.element_id == element_id
        );
        if (element) {
            if (remove) {
                element.services = element.services.filter(
                    es => es.id != service.id
                );
            } else {
                element.services.push(service);
            }
            if (element.size) {
                let elPrice = parseFloat(element.size.price);
                let elCost = parseFloat(element.size.cost);
                if (
                    element.material &&
                    parseFloat(element.material.cost_coefficient)
                ) {
                    elPrice *= parseFloat(element.material.cost_coefficient);
                    if (elCost) {
                        elCost *= parseFloat(element.material.cost_coefficient);
                    } else {
                        elPrice = elCost;
                    }

                }
                // elPrice += parseFloat(element.size.cost_coefficient);
                element.total = elPrice;
                element.totalCost = elCost;
            }

            if (element.polish) {
                element.total += parseFloat(element.polish.price);
                const costPolish = parseFloat(element.polish.cost);
                if (costPolish) {
                    element.totalCost += costPolish;
                }
            }
            if (element.services.length) {
                for (const service of element.services) {
                    element.total += service.price;
                    element.totalCost += service.cost;
                }
            }
        }
        state.elements[elementIndex] = element;
        state.elements = [...state.elements];
    },

    REMOVE_ELEMENT(state, element_id) {
        state.elements = state.elements.filter(
            el => el.element_id !== element_id
        );
        state.elements = [...state.elements];
    },

    UPDATE_WEIGHT(state) {
        state.weight = 0;
        for (const el of state.elements) {
            if (el.size && el.size.weight) {
                state.weight += el.size.weight;
            }
        }
    },

    UPDATE_TOTAL(state) {
        state.total = 0;
        state.totalCost = 0;
        state.engravingTotal = 0;
        state.addedElementsInstallTotal = 0;
        state.installTotal = 0;
        state.engravingTotalCost = 0;
        state.addedElementsInstallTotalCost = 0;
        state.installTotalCost = 0;

        for (const el of state.elements) {
            if (el.total) {
                state.total += el.total;
                state.totalCost += el.totalCost;
            }
            if (el.size) {
                state.addedElementsInstallTotal += el.size.cost_coefficient;
            }
        }

        for (const key in state.landscaping) {
            if (state.landscaping[key] && state.landscaping[key].total) {
                state.total += parseFloat(state.landscaping[key].total);
                state.totalCost += parseFloat(state.landscaping[key].totalCost);
            }
        }

        for (const i in state.faces) {

            let faceTotal = 0;
            let faceTotalCost = 0;

            if (state.faces[i].elements.length > 0) {
                for (const element of state.faces[i].elements) {
                    if (
                        element.size &&
                        element.size.price &&
                        parseFloat(element.size.price)
                    ) {

                        let amount = parseFloat(element.size.price);
                        let amountCost = parseFloat(element.size.cost);

                        if (element.type_calc_cost == 'cub') {

                            element.size.price = amount = parseFloat(element.width) * parseFloat(element.height) * parseFloat(element.nominal_size_price)

                            if (amountCost) {
                                element.size.cost = amountCost = parseFloat(element.width) * parseFloat(element.height) * parseFloat(element.nominal_size_cost)
                            } else {
                                element.size.cost = amountCost = element.size.price;
                            }
                        }

                        state.engravingTotal += amount;
                        state.engravingTotalCost += amountCost;

                        faceTotal += amount;
                        faceTotalCost += amountCost;
                    }
                }
            }

            if (state.faces[i].texts.length > 0) {
                for (const txt of state.faces[i].texts) {
                    if (txt.total) {

                        state.engravingTotal += parseFloat(txt.total);
                        faceTotal += parseFloat(txt.total);
                        const txtTotalCost = parseFloat(txt.totalCost);
                        if (txtTotalCost) {
                            state.engravingTotalCost += parseFloat(txt.totalCost);
                            faceTotalCost += parseFloat(txt.totalCost);
                        } else {
                            state.engravingTotalCost += parseFloat(txt.total);
                            faceTotalCost += parseFloat(txt.total);
                        }

                    }
                }
            }
            state.faces[i].total = faceTotal;
            state.faces[i].totalCost = faceTotalCost;
        }

        if (state.additionalWorks) {
            for (const key in state.additionalWorks) {

                if (state.additionalWorks[key]) {
                    const workCost = state.additionalWorks[key].cost;
                    state.total += state.additionalWorks[key].price;
                    if (workCost) {
                        state.totalCost += workCost;
                    } else {
                        state.totalCost += state.additionalWorks[key].price;
                    }

                }
            }

            if (state.additionalWorks.install) {

                state.total += state.addedElementsInstallTotal;
                state.totalCost += state.addedElementsInstallTotalCost;

                if (state.barrier && state.barrier.final_price_installation) {
                    state.total += state.barrier.final_price_installation;
                    if (state.barrier.final_cost_installation) {
                        state.total += state.barrier.final_cost_installation;
                    } else {
                        state.total += state.barrier.final_price_installation;
                    }
                }
            }
        }

        if (state.barrier) {
            state.total += state.barrier.total;
            state.totalCost += state.barrier.totalCost;

            if (state.landscaping.mainElement) {
                //прибавлять стоимость установки в основание
                state.barrier.final_price_installation =
                    state.barrier.price_installation_in_base;
                const costInstallationInBase = state.barrier.cost_installation_in_base;
                if (costInstallationInBase) {
                    state.barrier.final_cost_installation = costInstallationInBase;
                } else {
                    state.barrier.final_cost_installation = state.barrier.price_installation_in_base;
                }

            } else {
                //прибавлять обычную стоимость установки
                state.barrier.final_price_installation =
                    state.barrier.price_installation;
                const barrierCostInstallation = state.barrier.cost_installation;
                if (barrierCostInstallation) {
                    state.barrier.final_cost_installation = barrierCostInstallation;
                } else {
                    state.barrier.final_cost_installation = state.barrier.price_installation;
                }

            }

            // state.total += state.barrier.final_price_installation;

            if (
                state.barrier.doorPosition &&
                state.barrier.doorPosition.wherePlace == "placeCenter" &&
                parseFloat(state.barrier.price_add_stolbik)
            ) {
                state.total += parseFloat(state.barrier.price_add_stolbik);
                const barrierCostAddStolbik = parseFloat(state.barrier.cost_add_stolbik);
                if (barrierCostAddStolbik) {
                    state.totalCost += barrierCostAddStolbik;
                } else {
                    state.totalCost += parseFloat(state.barrier.price_add_stolbik);
                }

            }
        }

        state.total += state.engravingTotal;
        state.totalCost += state.engravingTotalCost;
    },

    UPDATE_SORT_ELEMENT(state) {
        state.elements = state.elements.sort(function (a, b) {
            if (a.element_group_id > b.element_group_id) {
                return 1;
            } else if (a.element_group_id < b.element_group_id) {
                return -1;
            }
        });
    },

    SET_MESH_ID_ELEMENT(state, { elementId, meshId }) {
        const elementIndex = state.elements.findIndex(
            el => el.element_id == elementId
        );
        if (elementIndex === 0 || elementIndex > 0) {
            state.elements[elementIndex].meshId = meshId
        }
    },

    SET_MESH_ID_LANSCAPING_MAIN_ELEMENT(state, { meshId }) {
        state.landscaping['mainElement']['meshId'] = meshId
    },

    SET_POSITION_ELEMENT(state, { meshId, position }) {
        const elementIndex = state.elements.findIndex(
            el => el.meshId == meshId
        );
        if (elementIndex === 0 || elementIndex > 0) {
            state.elements[elementIndex].position = position;
        }
    },

    SET_POSITION_LANSCAPING_MAIN_ELEMENT(state, { meshId, position }) {
        state.landscaping['mainElement']['position'] = position
    },

    SET_ROTATE_LANSCAPING_MAIN_ELEMENT(state, { meshId, rotate }) {
        state.landscaping['mainElement']['rotate'] = rotate
    },

    SET_ROTATE_ELEMENT(state, { meshId, rotate }) {
        const elementIndex = state.elements.findIndex(
            el => el.meshId == meshId
        );
        if (elementIndex === 0 || elementIndex > 0) {
            state.elements[elementIndex].rotate = rotate;
        }
    },

    CLEAR_ORDER(state) {
        state.plot = null;
        state.barrier = null;
        state.elements = [];
        state.faces = [];
        state.activeFaceIndex = null;
        state.orderIdFromCache = null;
        state.name = "";
        state.phone = "";
        state.email = "";
        state.total = 0;
        state.totalCost = 0;
        state.engravingTotal = 0;
        state.addedElementsInstallTotal = 0;
        state.installTotal = 0;
        state.engravingTotalCost = 0;
        state.addedElementsInstallTotalCost = 0;
        state.installTotalCost = 0;
        state.weight = 0;
        state.landscaping = {
            mainElementType: null,
            mainElement: null,
            facing_top: null,
            facing_side: null,
            fillType: null,
            fillElement: null,
            borderElement: null
        };
        state.additionalWorks = {
            install: null
        };
        state.mockup = "";
        state.successOrder = null;
        state.changed = false;
    },

    SET_ORDER_FROM_CACHE(state, order) {
        if (order) {
            state.plot = order.plot;
            state.mockup = order.mockup;
            state.barrier = order.barrier;
            state.elements = order.elements;
            
            // Сохраняем существующие finalImage перед перезаписью из кэша
            // так как cacheOrder не сохраняет finalImage (из-за размера)
            const existingFinalImages = {};
            if (state.faces && state.faces.length > 0) {
                state.faces.forEach(face => {
                    if (face.finalImage && face.finalImage.startsWith('data:image') && face.finalImage.length > 100) {
                        existingFinalImages[face.face_id] = face.finalImage;
                        console.log(`Preserving finalImage for face ${face.face_id} (${face.faceName || 'unnamed'}), size: ${(face.finalImage.length / 1024).toFixed(2)} KB`);
                    }
                });
            }
            
            // Восстанавливаем finalImage из существующего state, если они есть
            if (order.faces && order.faces.length > 0) {
                let restoredCount = 0;
                order.faces = order.faces.map(face => {
                    if (existingFinalImages[face.face_id]) {
                        restoredCount++;
                        return { ...face, finalImage: existingFinalImages[face.face_id] };
                    }
                    return face;
                });
                if (restoredCount > 0) {
                    console.log(`Restored ${restoredCount} finalImage(s) from state when loading from cache`);
                }
            }
            
            state.faces = order.faces;
            state.activeFaceIndex = order.activeFaceIndex;
            state.name = order.name;
            state.phone = order.phone;
            state.email = order.email;
            state.total = order.total;
            state.totalCost = order.totalCost;
            state.engravingTotalCost = order.engravingTotalCost;
            state.addedElementsInstallTotalCost = order.addedElementsInstallTotalCost;
            state.installTotalCost = order.installTotalCost;
            state.weight = order.weight;
            state.landscaping = order.landscaping;
            state.additionalWorks = order.additionalWorks
                ? order.additionalWorks
                : {
                    install: null
                };
        }
    },

    ADD_LANDSCAPING(state, { element, position }) {

        state.landscaping[position] = element;

        state.landscaping = { ...state.landscaping };
    },
    REMOVE_LANDSCAPING(state, position) {
        state.landscaping[position] = null;
        state.landscaping = { ...state.landscaping };
    },

    CLEAR_LANDSCAPING(state) {
        state.landscaping = {
            mainElementType: null,
            mainElement: null,
            facing_top: null,
            facing_side: null,
            fillType: null,
            fillElement: null,
            borderElement: null
        };
        state.landscaping = { ...state.landscaping };
    }
};

export const actions = {
    setPlot({ commit, dispatch }, plot) {
        commit("CLEAR_ORDER");
        commit("SET_PLOT", plot);
        dispatch("cacheOrder");
    },

    setPlotMode({ commit, dispatch }, mode) {
        commit("SET_PLOT_MODE", mode);
        dispatch("cacheOrder");
    },

    setPlotSize({ commit, dispatch }, { length, width }) {
        commit("SET_PLOT_SIZE", { length, width });
        dispatch("cacheOrder");
    },

    setRenderer({ commit }, renderer) {
        commit("SET_RENDERER", renderer);
    },

    setFaceImage({ commit, dispatch }, { faceId, image }) {
        commit("SET_FACE_IMAGE", { faceId, image });
        dispatch("cacheOrder");
    },

    setFaceFinalImage({ commit, dispatch }, { faceId, finalImage }) {
        commit("SET_FACE_FINAL_IMAGE", { faceId, finalImage });
        dispatch("cacheOrder");
    },

    addElement({ commit, dispatch }, element) {
        element = { ...element, meshId: null, position: { x: 0, y: 0, z: 0 }, rotate: 0 }
        const stateElement = state.elements.find(
            el => el.element_group_id == element.element_group_id
        );

        if (stateElement) {
            dispatch("Client3dInteractive/removeMovingUuid", stateElement.meshId, { root: true });
        }


        commit("ADD_ELEMENT", element);
        commit("CLEAR_FACES_ELEMENT_GROUP", element.element_group_id);

        dispatch("addFacesElement", element.element_id);

        commit("UPDATE_SORT_ELEMENT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    setMeshIdElement({ commit, dispatch }, { elementId, meshId }) {
        commit('SET_MESH_ID_ELEMENT', { elementId, meshId });
        dispatch("cacheOrder");
    },
    setMeshIdLandscapingMainElement({ commit, dispatch }, { meshId }) {
        commit('SET_MESH_ID_LANSCAPING_MAIN_ELEMENT', { meshId });
        dispatch("cacheOrder");
    },

    setPositionElement({ commit, dispatch }, { meshId, position }) {
        commit('SET_POSITION_ELEMENT', { meshId, position });
        dispatch("cacheOrder");
    },

    setPositionLandscapingMainElement({ commit, dispatch }, { meshId, position }) {
        commit('SET_POSITION_LANSCAPING_MAIN_ELEMENT', { meshId, position });
        dispatch("cacheOrder");
    },

    setRotateElement({ commit, dispatch }, { meshId, rotate }) {
        commit('SET_ROTATE_ELEMENT', { meshId, rotate });
        dispatch("cacheOrder");
    },

    setRotateLandscapingMainElement({ commit, dispatch }, { meshId, rotate }) {
        commit('SET_ROTATE_LANSCAPING_MAIN_ELEMENT', { meshId, rotate });
        dispatch("cacheOrder");
    },

    addFacesElement({ commit, state }, element_id) {
        const element = state.elements.find(el => el.element_id == element_id);
        if (element) {
            if (element.faces && element.faces.length) {

                for (const face of element.faces) {

                    const faceLabel = i18n.global.t(`main.face_${element.element_group_slug}`);
                    let faceName =
                        "<span>" +
                        faceLabel +
                        "</span><span>" +
                        face.name +
                        "</span>";

                    commit("ADD_FACE", {
                        face_id: uuidv4(),
                        id: face.id,
                        element_id: element.element_id,
                        element_group_id: element.element_group_id,
                        element: element,
                        faceName: faceName,
                        rotate_x: face.rotate_x,
                        rotate_y: face.rotate_y,
                        rotate_z: face.rotate_z,
                        image: null,
                        finalImage: null,
                        texts: [],
                        elements: [],
                        total: 0,
                        totalCost: 0
                    });
                }
            }
        }
    },

    setActiveFace({ commit, dispatch, state }, face) {
        const faceIndex = state.faces.findIndex(
            fc => fc.face_id == face.face_id
        );
        if (faceIndex >= 0) {
            commit("SET_ACTIVE_FACE_INDEX", faceIndex);
        }
        dispatch("cacheOrder");
    },

    setFaceFinalImage({ commit, dispatch }, { faceId, finalImage }) {
        commit('SET_FACE_FINAL_IMAGE', { faceId, finalImage });
        dispatch("cacheOrder");
    },

    setMockup({ commit, dispatch }, mockup) {
        commit('SET_MOCKUP', mockup);
        dispatch("cacheOrder");
    },

    selectEngraving({ commit, dispatch, state }, element) {
        if (state.activeFaceIndex === null) {
            const notification = {
                element: "error",
                message: "Необходимо выбрать активную грань"
            };
            dispatch("notification/add", notification, { root: true });
            return false;
        }

        element['uuid'] = uuidv4();
        element['changeFromScene'] = null;
        element['action'] = '';

        commit("SELECT_ENGRAVING", element);
        commit("SET_ENGRAVINGS_UPDATED_AT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateEngravingMeshId({ commit, dispatch }, { element_uuid, meshId }) {
        commit("UPDATE_ENGRAVING_MESH_ID", { element_uuid, meshId });
        // commit('UPDATE_TOTAL');
        // dispatch('cacheOrder');
    },

    getEngravingElementByMeshId({ state }, meshId) {
        const engrElIndex = state.faces[
            state.activeFaceIndex
        ].elements.findIndex(el => el.meshId == meshId);
        if (engrElIndex == 0 || engrElIndex > 0) {
            return state.faces[state.activeFaceIndex].elements[engrElIndex];
        } else {
            const textIndex = state.faces[
                state.activeFaceIndex
            ].texts.findIndex(txt => txt.meshId == meshId);
            if (
                textIndex != null &&
                state.faces[state.activeFaceIndex].texts[textIndex]
            ) {
                return state.faces[state.activeFaceIndex].texts[textIndex];
            } else {
                return null;
            }
        }
    },

    updateEngravingSize({ commit, dispatch, state }, { element_id, size }) {
        commit("UPDATE_ENGRAVING_SIZE", { element_id, size });
        commit("CLEAR_ACTIVE_FACE_FINAL_IMAGE");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateEngravingElement({ commit, dispatch }, { element_uuid, value, key }) {
        commit("UPDATE_ENGRAVING_ELEMENT", { element_uuid, value, key });
        commit("CLEAR_ACTIVE_FACE_FINAL_IMAGE");
        commit("SET_ENGRAVINGS_UPDATED_AT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateEngravingPosition({ commit, dispatch }, moveObj) {
        commit("UPDATE_ENGRAVING_POSITION", moveObj);
        dispatch("cacheOrder");
    },

    updateFaces({ commit, dispatch }) {
        commit("UPDATE_FACES");
        dispatch("cacheOrder");
    },

    removeEngraving({ commit, dispatch }, { face_id, element_id, uuid = null }) {
        commit("REMOVE_ENGRAVING", { face_id, element_id, uuid });
        commit("CLEAR_FACE_FINAL_IMAGE", { faceId: face_id });
        commit("SET_ENGRAVINGS_UPDATED_AT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    removeEngravingFaceElements({ commit, dispatch }, face_id) {
        commit("REMOVE_ENGRAVING_FACE_ELEMENTS", face_id);
        commit("CLEAR_FACE_FINAL_IMAGE", { faceId: face_id });
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    addText(
        { commit, dispatch },
        { font, position, price, size, text = "Текст", cost_coef = 1, cost = 0, }
    ) {
        if (state.activeFaceIndex === null) {
            const notification = {
                element: "error",
                message: "Необходимо выбрать активную грань"
            };
            dispatch("notification/add", notification, { root: true });
            return false;
        }

        let count = text.length;

        let total =
            parseFloat(price) * count * parseFloat(size.cost_coefficient);

        let totalCost = parseFloat(price) * count * parseFloat(size.cost_coefficient);
        if (cost) {
            totalCost = parseFloat(cost) * count * parseFloat(size.cost_coefficient);
        }

        const text_id = uuidv4();

        commit("ADD_TEXT", {
            text_id,
            meshId: 0,
            font,
            position,
            price,
            cost,
            size,
            text,
            count,
            total,
            totalCost,
            angle: 0,
            horizontalAlignment: '',
            verticallAlignment: '',
            isText: true,
            layer: 0.0001,
            offsetTop: 0,
            offsetLeft: 0,
            offsetCenterY: 0,
            offsetCenterX: 0,
            offsetMaxY: 0,
            offsetMaxX: 0,
            element_id: text_id,
            uuid: text_id,
            changeFromScene: null,
            action: ''
        });
        commit("CLEAR_ACTIVE_FACE_FINAL_IMAGE");
        commit("SET_ENGRAVINGS_UPDATED_AT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    setText({ commit, dispatch }, setText) {
        commit("SET_TEXT", setText);
        commit("CLEAR_ACTIVE_FACE_FINAL_IMAGE");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    removeText({ commit, dispatch }, { face_id, text_id }) {
        commit("REMOVE_TEXT", { face_id, text_id });
        commit("CLEAR_FACE_FINAL_IMAGE", { faceId: face_id });
        commit("SET_ENGRAVINGS_UPDATED_AT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    addBarrier({ commit, dispatch, state }, barrier) {
        let perimetr =
            ((parseFloat(state.plot.width) + parseFloat(state.plot.length)) /
                100) *
            2;

        barrier.sizes = `${state.plot.width} x ${state.plot.length}`;
        barrier.perimetr = perimetr;

        barrier.total = barrier.price_pog_metr * perimetr;
        const barrierCostPogMetr = barrier.cost_pog_metr;
        if (barrierCostPogMetr) {
            barrier.totalCost = barrierCostPogMetr * perimetr;
        } else {
            barrier.totalCost = barrier.total;
        }


        barrier.kalitka = "";

        let arKalitka = [];

        if (barrier.bez_kalitki) {
            arKalitka.push("без калитки");
        }
        if (barrier.bez_prohoda) {
            arKalitka.push("без прохода");
        }
        if (!barrier.bez_prohoda && barrier.bez_kalitki) {
            arKalitka.push("проход");
        }
        if (!barrier.bez_kalitki && !barrier.bez_prohoda) {
            arKalitka.push(
                `сторона: ${barrier.doorPosition.side.toUpperCase()}`
            );
            let obgLang = {
                placeCenter: "по центру",
                placeLeft: "слева",
                placeRight: "справа",
                left: "влево",
                right: "вправо",
                out: "наружу",
                in: "во внутрь"
            };

            arKalitka.push(obgLang[barrier.doorPosition.wherePlace]);
            arKalitka.push(obgLang[barrier.doorPosition.how]);
            arKalitka.push(obgLang[barrier.doorPosition.where]);
        }
        if (barrier.bez_kalitki && !barrier.bez_prohoda) {
            arKalitka.push(
                `сторона: ${barrier.doorPosition.side.toUpperCase()}`
            );
        }

        barrier.kalitka = arKalitka.join(", ");

        if (state.landscaping.mainElement) {
            barrier.final_price_installation =
                barrier.price_installation_in_base;

            if (barrier.cost_installation_in_base) {
                barrier.final_cost_installation =
                    barrier.cost_installation_in_base;
            } else {
                barrier.final_cost_installation =
                    barrier.price_installation_in_base;
            }

        } else {
            barrier.final_price_installation = barrier.price_installation;
            if (barrier.cost_installation) {
                barrier.final_cost_installation = barrier.cost_installation;
            } else {
                barrier.final_cost_installation = barrier.price_installation;
            }

        }

        commit("ADD_BARRIER", barrier);
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    removeBarrier({ commit, dispatch }) {
        commit("REMOVE_BARRIER");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    addLandscaping({ commit, state, dispatch }, { element, position }) {
        element = {
            ...element,
            size: element?.size ? { ...element.size } : element?.size,
            base_size: element?.base_size
                ? { ...element.base_size }
                : element?.base_size,
            sizes: Array.isArray(element?.sizes)
                ? element.sizes.map((s) => ({ ...s }))
                : element?.sizes,
            position: element?.position ? { ...element.position } : element?.position,
        };

        if (!element.size && Array.isArray(element.sizes) && element.sizes.length) {
            element.size = { ...element.sizes[0] };
        }

        let square = 0;
        let volume = 0;
        let total = 0;
        let totalCost = 0;
        let thickness = 0;
        let perimeter = 0;

        if (!element.base_price_preparation) {
            element.base_price_preparation = element.price_preparation;
        }

        if (!element.base_cost_preparation) {
            element.base_cost_preparation = element.cost_preparation;
        } else {
            element.base_cost_preparation = element.price_preparation || 0;
        }

        if (position == "mainElement") {
            if (state.landscaping.mainElement) {
                dispatch("Client3dInteractive/removeMovingUuid", state.landscaping.mainElement.meshId, { root: true });
            }
            if (element.element_group_slug == "plate-fill") {
                if (!element.individual_size_material && state.plot) {
                    element.size.width = parseFloat(state.plot.width);
                    element.size.length = parseFloat(state.plot.length);
                    square =
                        (parseFloat(state.plot.width) / 100) *
                        (parseFloat(state.plot.length) / 100);
                    volume =
                        square *
                        (parseFloat(element.size.height) / 100 +
                            parseFloat(element.size.depth) / 100);

                    total = volume * parseFloat(element.size.price);
                    const sizeCost = parseFloat(element.size.cost);
                    if (sizeCost) {
                        totalCost = volume * sizeCost;
                    } else {
                        totalCost = total;
                    }

                    element.price_preparation =
                        element.base_price_preparation * square;

                    if (element.base_cost_preparation) {
                        element.cost_preparation =
                            element.base_cost_preparation * square;
                    } else {
                        element.cost_preparation = element.price_preparation;
                    }



                    total += parseFloat(element.price_preparation);

                    totalCost += parseFloat(element.cost_preparation);


                } else {
                    const thumb = state.elements.find(
                        el => el.element_group_slug == "tumby"
                    );
                    const cvetnik = state.elements.find(
                        el => el.element_group_slug == "cvetniki-nadgrobiya"
                    );
                    if (!thumb || !cvetnik || !thumb.size || !cvetnik.size) {
                        const notification = {
                            type: "error",
                            message:
                                "Для выбора данного основания необходимо выбрать размеры цветника и тумбы"
                        };
                        dispatch("notification/add", notification, {
                            root: true
                        });
                        return false;
                    } else {
                        const maxWidth =
                            parseFloat(thumb.size.width) >
                                parseFloat(cvetnik.size.width)
                                ? parseFloat(thumb.size.width)
                                : parseFloat(cvetnik.size.width);
                        element.base_size.width = maxWidth;
                        let vistupWidth = 0;
                        if (parseFloat(element.vistup_left)) {
                            vistupWidth += parseFloat(element.vistup_left);
                        }
                        if (parseFloat(element.vistup_right)) {
                            vistupWidth += parseFloat(element.vistup_right);
                        }
                        element.size.width = maxWidth + vistupWidth;

                        let vistupLength = 0;
                        if (parseFloat(element.vistup_front)) {
                            vistupLength += parseFloat(element.vistup_front);
                        }
                        if (parseFloat(element.vistup_back)) {
                            vistupLength += parseFloat(element.vistup_back);
                        }
                        const elLength = parseFloat(thumb.size.length) +
                            parseFloat(cvetnik.size.length)
                        element.base_size.length = elLength;

                        element.size.length =
                            elLength +
                            vistupLength;

                        square =
                            (parseFloat(element.size.width) / 100) *
                            (parseFloat(element.size.length) / 100);
                        volume =
                            square *
                            (parseFloat(element.size.height) / 100 +
                                parseFloat(element.size.depth) / 100);

                        total = volume * parseFloat(element.size.price);

                        const sizeCost = parseFloat(element.size.cost);
                        if (sizeCost) {
                            totalCost = volume * sizeCost;
                        } else {
                            totalCost = total;
                        }

                        element.price_preparation =
                            element.base_price_preparation * square;

                        if (element.base_cost_preparation) {
                            element.cost_preparation =
                                element.base_cost_preparation * square;
                        } else {
                            element.cost_preparation = element.price_preparation;
                        }

                        total += parseFloat(element.price_preparation);
                        totalCost += parseFloat(element.cost_preparation);
                    }
                }
            }

            if (element.element_group_slug == "stripe") {

                thickness = parseFloat(element.base_size.width);

                if (!element.individual_size_material && state.plot) {
                    element.size.width = parseFloat(state.plot.width);
                    element.size.length = parseFloat(state.plot.length);

                    const squareBigPlate =
                        (element.size.width / 100) *
                        (element.size.length / 100);
                    const widthSmallPlate = element.size.width - thickness * 2;
                    const lengthSmallPlate =
                        element.size.length - thickness * 2;
                    const squareSmallPlate =
                        (widthSmallPlate / 100) * (lengthSmallPlate / 100);
                    element.squareSmallPlate = squareSmallPlate;
                    square = squareBigPlate - squareSmallPlate;

                    const fullHeight =
                        (parseFloat(element.size.height) +
                            parseFloat(element.size.depth)) /
                        100;

                    volume = square * fullHeight;


                    total = volume * parseFloat(element.size.price);
                    const sizeCost = parseFloat(element.size.cost);
                    if (sizeCost) {
                        totalCost = volume * parseFloat(sizeCost);
                    } else {
                        totalCost = total;
                    }

                    element.price_preparation =
                        element.base_price_preparation * square;

                    total += parseFloat(element.price_preparation);

                    if (element.base_cost_preparation) {
                        element.cost_preparation =
                            element.base_cost_preparation * square;
                        totalCost += parseFloat(element.cost_preparation);
                    } else {
                        element.cost_preparation =
                            element.base_price_preparation * square;
                        totalCost += parseFloat(element.price_preparation);
                    }

                } else {
                    const thumb = state.elements.find(
                        el => el.element_group_slug == "tumby"
                    );
                    const cvetnik = state.elements.find(
                        el => el.element_group_slug == "cvetniki-nadgrobiya"
                    );

                    if (!thumb || !cvetnik || !thumb.size || !cvetnik.size) {
                        const notification = {
                            type: "error",
                            message:
                                "Для выбора данного основания необходимо выбрать размеры цветника и тумбы"
                        };
                        dispatch("notification/add", notification, {
                            root: true
                        });
                        return false;
                    } else {
                        const maxWidth =
                            parseFloat(thumb.size.width) >
                                parseFloat(cvetnik.size.width)
                                ? parseFloat(thumb.size.width)
                                : parseFloat(cvetnik.size.width);

                        let vistupWidth = 0;
                        if (parseFloat(element.vistup_left)) {
                            vistupWidth += parseFloat(element.vistup_left);
                        } else {
                            vistupWidth += 15;
                        }
                        if (parseFloat(element.vistup_right)) {
                            vistupWidth += parseFloat(element.vistup_right);
                        } else {
                            vistupWidth += 15;
                        }

                        element.size.width = maxWidth + vistupWidth + 2 * thickness;

                        let vistupLength = 0;
                        if (parseFloat(element.vistup_front)) {
                            vistupLength += parseFloat(element.vistup_front);
                        } else {
                            vistupLength += 15;
                        }
                        if (parseFloat(element.vistup_back)) {
                            vistupLength += parseFloat(element.vistup_back);
                        } else {
                            vistupLength += 15;
                        }
                        const elLength = parseFloat(thumb.size.length) +
                            parseFloat(cvetnik.size.length)


                        element.size.length =
                            elLength +
                            vistupLength
                            + 2 * thickness;

                        const squareBigPlate =
                            (element.size.width / 100) *
                            (element.size.length / 100);
                        const widthSmallPlate =
                            element.size.width - thickness * 2;
                        const lengthSmallPlate =
                            element.size.length - thickness * 2;
                        const squareSmallPlate =
                            (widthSmallPlate / 100) * (lengthSmallPlate / 100);

                        element.squareSmallPlate = squareSmallPlate;

                        square = squareBigPlate - squareSmallPlate;

                        volume =
                            square *
                            (parseFloat(element.size.height) / 100 +
                                parseFloat(element.size.depth) / 100);

                        total = volume * parseFloat(element.size.price);
                        element.price_preparation =
                            element.base_price_preparation * square;

                        total += parseFloat(element.price_preparation);

                        const sizeCost = parseFloat(element.size.cost);
                        if (sizeCost) {
                            totalCost = volume * sizeCost;
                        } else {
                            totalCost = total;
                        }

                        if (element.base_cost_preparation) {
                            element.cost_preparation =
                                element.base_cost_preparation * square;
                        } else {
                            element.cost_preparation =
                                element.base_price_preparation * square;
                        }
                        totalCost += parseFloat(element.cost_preparation);
                    }
                }

                if (state.landscaping.fillElement) {

                    state.landscaping.fillElement.square = parseFloat(element.squareSmallPlate);

                    state.landscaping.fillElement.total = state.landscaping.fillElement.size.price * element.squareSmallPlate;

                    if (state.landscaping.fillElement.size.cost) {
                        state.landscaping.fillElement.totalCost = state.landscaping.fillElement.size.cost * element.squareSmallPlate;
                    } else {
                        state.landscaping.fillElement.totalCost = state.landscaping.fillElement.size.price * element.squareSmallPlate;
                    }

                    state.landscaping.fillElement.price_preparation =
                        state.landscaping.fillElement.base_price_preparation * element.squareSmallPlate;

                    if (state.landscaping.fillElement.base_cost_preparation) {
                        state.landscaping.fillElement.cost_preparation =
                            state.landscaping.fillElement.base_cost_preparation * element.squareSmallPlate;
                    } else {
                        state.landscaping.fillElement.cost_preparation =
                            state.landscaping.fillElement.base_price_preparation * element.squareSmallPlate;
                    }

                    state.landscaping.fillElement.total += parseFloat(state.landscaping.fillElement.price_preparation);

                    state.landscaping.fillElement.totalCost += parseFloat(state.landscaping.fillElement.cost_preparation);

                    state.landscaping.fillElement.square = state.landscaping.fillElement.square.toFixed(2);
                }
            }

            if (
                (element.element_group_slug == "paving" ||
                    element.element_group_slug == "pour" ||
                    element.element_group_slug == "grass")
            ) {
                if (state.plot) {
                    square =
                        parseFloat(state.plot.width / 100) *
                        parseFloat(state.plot.length / 100);
                    total = square * parseFloat(element.size.price);
                    const sizeCost = parseFloat(element.size.cost);
                    if (sizeCost) {
                        totalCost = square * sizeCost;
                    } else {
                        totalCost = total;
                    }
                }

                element.price_preparation =
                    element.base_price_preparation * square;

                total += element.price_preparation;
                if (element.base_cost_preparation) {
                    element.cost_preparation =
                        element.base_cost_preparation * square;
                } else {
                    element.cost_preparation =
                        element.base_price_preparation * square;
                }

                totalCost += element.cost_preparation;
            }

        }

        if (position == "facing_top") {
            if (
                state.landscaping.mainElement.element_group_slug ==
                "plate-fill" ||
                state.landscaping.mainElement.element_group_slug == "stripe"
            ) {
                square = state.landscaping.mainElement.square;
                total = element.size.price * square;
                const sizeCost = element.size.cost;
                if (sizeCost) {
                    totalCost = element.size.cost * square;
                } else {
                    totalCost = total;
                }
            }
        }


        if (position == "facing_side") {
            if (
                state.landscaping.mainElement.element_group_slug ==
                "plate-fill" ||
                state.landscaping.mainElement.element_group_slug == "stripe"
            ) {
                const square1 =
                    (parseFloat(state.landscaping.mainElement.size.width) /
                        100) *
                    (parseFloat(state.landscaping.mainElement.size.height) /
                        100) *
                    2;
                const square2 =
                    (parseFloat(state.landscaping.mainElement.size.length) /
                        100) *
                    (parseFloat(state.landscaping.mainElement.size.height) /
                        100) *
                    2;

                square = square1 + square2;
                total = element.size.price * square;

                const sizeCost = element.size.cost;

                if (sizeCost) {
                    totalCost = sizeCost * square;
                } else {
                    totalCost = total;
                }
            }
        }

        if (position == "fillElement") {
            if (state.landscaping.mainElement.element_group_slug == "stripe") {
                //нужно из общей площади участка вычесть площадь цветника с тумбой и площадь полосы

                square = parseFloat(state.landscaping.mainElement.squareSmallPlate);

                total = element.size.price * square;

                element.price_preparation =
                    element.base_price_preparation * square;

                total += parseFloat(element.price_preparation);

                if (element.size.cost) {
                    totalCost = element.size.cost * square;
                } else {
                    totalCost = total;
                }

                if (element.base_cost_preparation) {
                    element.cost_preparation =
                        element.base_cost_preparation * square;
                } else {
                    element.cost_preparation =
                        element.base_price_preparation * square;
                }

                totalCost += parseFloat(element.cost_preparation);
            }
        }

        if (position == "borderElement") {
            if (
                state.landscaping.mainElement.element_group_slug == "paving" ||
                state.landscaping.mainElement.element_group_slug == "pour" ||
                state.landscaping.mainElement.element_group_slug == "grass"
            ) {
                perimeter =
                    (parseFloat(state.plot.width) * 2) / 100 +
                    (parseFloat(state.plot.length) * 2) / 100;

                total = element.size.price * perimeter;

                element.price_preparation =
                    element.base_price_preparation * perimeter;

                total += parseFloat(element.price_preparation);

                const sizeCost = element.size.cost;
                if (sizeCost) {
                    totalCost = sizeCost * perimeter;
                } else {
                    totalCost = total;
                }

                if (element.base_cost_preparation) {
                    element.cost_preparation =
                        element.base_cost_preparation * perimeter;
                } else {
                    element.cost_preparation =
                        element.base_price_preparation * perimeter;
                }

                totalCost += parseFloat(element.cost_preparation);
            }
        }

        element.square = parseFloat(square)
            ? parseFloat(square.toFixed(2))
            : parseFloat(square);
        element.volume = parseFloat(volume)
            ? parseFloat(volume.toFixed(2))
            : parseFloat(volume);

        element.total = parseFloat(total)
            ? parseFloat(total.toFixed(2))
            : parseFloat(total);
        element.totalCost = parseFloat(totalCost)
            ? parseFloat(totalCost.toFixed(2))
            : parseFloat(totalCost);
        element.thickness = parseFloat(thickness)
            ? parseFloat(thickness.toFixed(2))
            : parseFloat(thickness);
        element.perimeter = parseFloat(perimeter)
            ? parseFloat(perimeter.toFixed(2))
            : parseFloat(perimeter);

        commit("ADD_LANDSCAPING", { element, position });
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    removeLandscaping({ commit, dispatch }, position) {
        if (position == "mainElement") {
            dispatch("clearLandscaping");
        } else {
            commit("REMOVE_LANDSCAPING", position);
        }
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    clearLandscaping({ commit, state, dispatch }) {
        if (state.landscaping.mainElement) {
            dispatch("Client3dInteractive/removeMovingUuid", state.landscaping.mainElement.meshId, { root: true });
        }
        commit("CLEAR_LANDSCAPING");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    addAdditionalWork({ commit, dispatch }, { type, additionalWork }) {
        commit("ADD_ADDITIONAL_WORK", { type, additionalWork });
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },
    removeAdditionalWork({ commit, dispatch }, type) {
        commit("REMOVE_ADDITIONAL_WORK", type);
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateElementSize({ commit, dispatch }, { element_id, size }) {

        commit("UPDATE_ELEMENT_SIZE", { element_id, size });

        // обновить элемент в faces!

        // commit("REMOVE_FACE_ELEMENT", element_id);
        // dispatch("addFacesElement", element_id);

        commit("UPDATE_WEIGHT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateElementPolish({ commit, dispatch }, { element_id, polish }) {
        commit("UPDATE_ELEMENT_POLISH", { element_id, polish });
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateElementService(
        { commit, dispatch },
        { element_id, service, remove = false }
    ) {
        commit("UPDATE_ELEMENT_SERVICE", { element_id, service, remove });
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    updateElementMaterial({ commit, dispatch }, { element_id, material }) {
        commit("UPDATE_ELEMENT_MATERIAL", { element_id, material });

        // commit("REMOVE_FACE_ELEMENT", element_id);
        // dispatch("addFacesElement", element_id);

        commit("UPDATE_WEIGHT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    removeElement({ commit, dispatch }, element_id) {
        commit("REMOVE_ELEMENT", element_id);
        commit("REMOVE_FACE_ELEMENT", element_id);
        commit("UPDATE_WEIGHT");
        commit("UPDATE_TOTAL");
        dispatch("cacheOrder");
    },

    setChanged({ commit }, changed) {
        commit("SET_CHANGED", changed);
    },

    cacheOrder({ state, dispatch }) {
        // Очищаем большие данные (изображения) для экономии места в localStorage
        const facesToSave = state.faces.map(face => {
            return { ...face, finalImage: null, image: null };
        });
        const orderToCache = { ...state, faces: facesToSave };

        try {
            const orderKey = state.orderIdFromCache
                ? `orderEdit${state.orderIdFromCache}`
                : "order";

            // Очищаем старые данные перед сохранением
            localStorage.removeItem(orderKey);

            localStorage.setItem(orderKey, JSON.stringify(orderToCache));
        } catch (e) {
            if (e.name === 'QuotaExceededError' || e.code === 22) {
                console.warn('localStorage quota exceeded, clearing old orders');
                // Очищаем все старые заказы
                const keysToRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && (key.startsWith('order') || key.startsWith('orderEdit'))) {
                        keysToRemove.push(key);
                    }
                }
                keysToRemove.forEach(key => localStorage.removeItem(key));

                // Пробуем сохранить снова
                try {
                    const orderKey = state.orderIdFromCache
                        ? `orderEdit${state.orderIdFromCache}`
                        : "order";
                    localStorage.setItem(orderKey, JSON.stringify(orderToCache));
                } catch (retryError) {
                    console.error('Failed to cache order even after cleanup:', retryError);
                }
            } else {
                console.error('Failed to cache order:', e);
            }
        }
        dispatch('setChanged', true);
    },

    clearOrderEdit({ commit }, orderId) {
        commit("SET_ORDER_ID_FROM_CACHE", null);
        localStorage.removeItem(`orderEdit${orderId}`);
    },

    async getComplectation({ commit, dispatch, state }, { order_cache, load_element_id, load_barrier_id }) {
        if (load_barrier_id) {
            dispatch("clear");
            await dispatch("clientPlots/setDefaultPlot", {}, { root: true });

            try {

                const res = (await axios.get(`/api/get-barrier/${load_barrier_id}`))
                    .data;

                const barrier = res.data;

                if (barrier) {

                    const selectedElement = {
                        ...barrier, doorPosition: {
                            side: "c",
                            how: "left",
                            where: "out",
                            wherePlace: "placeRight",
                        },
                    }
                    dispatch('clientBarriers/setElement', selectedElement, { root: true });
                    dispatch('addBarrier', selectedElement)
                }

            } catch (error) {
                const notification = {
                    element: "error",
                    message:
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                };
                dispatch("notification/add", notification, { root: true });
            }
        } else if (load_element_id) {

            dispatch("clear");
            await dispatch("clientPlots/setDefaultPlot", {}, { root: true });

            try {

                const res = (await axios.get(`/api/get-element/${load_element_id}`))
                    .data;

                const element = res.data;

                if (element) {
                    dispatch("addElement", element);
                    dispatch("updateElementSize", {
                        element_id: element.element_id,
                        size: element.sizes[0]
                    });

                    if (element.type_calc_cost !== 'fix' && element.materials.length) {
                        dispatch("updateElementMaterial", {
                            element_id: element.element_id,
                            material: element.materials[0]
                        });
                    }
                }

            } catch (error) {
                const notification = {
                    element: "error",
                    message:
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                };
                dispatch("notification/add", notification, { root: true });
            }
        } else if (order_cache) {

            try {
                const res = (await axios.get(`/api/order-cache/${order_cache}`))
                    .data;
                commit("SET_ORDER_ID_FROM_CACHE", res.order_id);

                const orderCache = localStorage.getItem(`orderEdit${res.order_id}`);

                if (orderCache === null) {
                    commit("SET_ORDER_FROM_CACHE", JSON.parse(res.cache_string));
                } else {
                    commit("SET_ORDER_FROM_CACHE", JSON.parse(orderCache));
                    dispatch('setChanged', true);
                }
            } catch (error) {
                const notification = {
                    element: "error",
                    message:
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                };
                dispatch("notification/add", notification, { root: true });
            }
        } else {
            const cacheOrder = JSON.parse(localStorage.getItem("order"));
            commit(
                "SET_ORDER_FROM_CACHE",
                cacheOrder
            );
        }

        commit("UPDATE_TOTAL");
        if (!state.plot) {
            dispatch("clientPlots/setDefaultPlot", {}, { root: true });
        }
    },

    checkout() { },

    clear({ commit, dispatch }) {
        commit("CLEAR_ORDER");
        commit("UPDATE_TOTAL");
        localStorage.removeItem("order");
    },

    async fetchOrder({ dispatch }, order_id) {
        try {
            const res = (await axios.get(`/api/orders/${order_id}`)).data;
            return res.data;
        } catch (error) {
            const notification = {
                page: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    }
};



export const getters = {
    orderToSave(state) {
        const facesToSave = state.faces.map(face => {
            return { ...face, finalImage: null, image: null };
        });
        const orderToSave = {
            ...state,
            mockup: null,
            faces: facesToSave
        };

        return JSON.stringify(orderToSave);
    },
    activeFace(state) {
        return state.faces[state.activeFaceIndex];
    },
    orderIdFromCache(state) {
        return state.orderIdFromCache;
    },
    changed(state) {
        return state.changed;
    },
    selectedElement: state => element_group_slug => {
        return state.elements.find(
            el => el.element_group_slug == element_group_slug
        );
    },
    selectedBarriers: state => state.barrier,
    selectedLandscaping: state => state.landscaping
};
